import React, { useState, useEffect, useMemo } from "react";
import { Table, Badge, Dropdown } from "react-bootstrap";
import {
  getUserList,
  blockUser,
  deleteUser,
  getUserExportList,
  sendNotificationFemale,
  recoverAccountApi,
  hideProfileApi,
  activateAccountApi,
  getUserListInternal,
} from "../../services/UserServices/UserService";
import Spinner from "../components/Common/Spinner";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import Pagination from "../components/Common/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import dummmyImg from "../../images/profile/images.jpeg";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  activeStatusFilterPost,
  serachFilterPost,
} from "../../store/actions/FilterActions";
import * as XLSX from "xlsx";
import { selectConversationNull } from "../../store/actions/SessionActions";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";

const UsersTableInternal = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const imgBaseURl = "";
  const [loader, setLoader] = useState(false);
  const [users, setUsers] = useState([]);
  const [listLength, setListLength] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [imageForView, setImageForView] = useState("");
  const [view, setView] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    location?.state?.page ? location?.state?.page : 0
  );
  const searchFilter = useSelector((state) => state.filter.filter.search);
  const ageFilter = useSelector((state) => state.filter.filter.age);
  const locationFilter = useSelector((state) => state.filter.filter.location);
  const genderFilter = useSelector((state) => state.filter.filter.gender);
  const statusFilter = useSelector((state) => state.filter.filter.status);
  const formFilledFilter = useSelector(
    (state) => state.filter.filter.formFilled
  );
  const typeFilter = useSelector((state) => state.filter.filter.type);
  const activeStatusFilter = useSelector(
    (state) => state.filter.filter.activeStatus
  );

  const [search, setSearch] = useState(searchFilter);
  const [age, setAge] = useState(ageFilter);
  const [selectedCountry, setSelectedCountry] = useState(locationFilter);
  const [initialFetch, setInitialFetch] = useState(true);
  const [gender, setGender] = useState(genderFilter);
  const [status, setStatus] = useState(statusFilter);
  const [isFormFilled, setIsFormFilled] = useState(formFilledFilter);
  const [signUpType, setSignUpType] = useState(typeFilter);
  const [activeStatus, setActiveStatus] = useState(activeStatusFilter);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState("");
  const [newUsers, setNewUsers] = useState([]);
  const limit = 10;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [exportLoader, setExportLoader] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  function onDateChange(...args) {
    console.log(args, "args");
    setStartDate(moment(args[0]).format("YYYY-MM-DD"));
    {
      args[1]
        ? setEndDate(moment(args[1]).format("YYYY-MM-DD"))
        : setEndDate(null);
    }
  }
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const headers = [
    { label: "CONTACT ID", key: "_id" },
    { label: "EMAIL", key: "email" },
    { label: "FIRST NAME", key: "name" },
    { label: "LAST NAME", key: "" },
    { label: "SMS", key: "phoneNumber" },
  ];
  const getTableData = async () => {
    setLoader(true);
    try {
      const response = await getUserListInternal(currentPage, limit, search, activeStatus);
      setUsers(response.data.data.users);
      const total = response.data.data.count;
      setPageCount(Math.ceil(total / limit));
      setListLength(total);
      setLoader(false);
      setInitialFetch(false);
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
    }
  };

  const getTableDataSearch = async () => {
    setCurrentPage(0);
    getTableData();
  };

  function onReset() {
    // setDateRangePickerKey((prev) => prev + 1);
    setStartDate(null);
    setEndDate(null);
  }
  const onDelete = async (id) => {
    setLoader(true);
    try {
      const response = await deleteUser(deleteConfirmationId);
      notifyTopRight(response.data?.message);
      setLoader(false);
      getTableData();
      setShowDeleteModal(false);
      setDeleteConfirmationId("");
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onAction = async (id) => {
    setLoader(true);
    try {
      const response = await blockUser(id);
      notifyTopRight(response.data?.message);
      getTableData();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  useEffect(() => {
    getTableData();
  }, [
    currentPage,
    gender,
    selectedCountry,
    status,
    isFormFilled,
    signUpType,
    activeStatus,
    endDate,
  ]);

  let timeoutId;
  // Define a helper function for debouncing
  const debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const debouncedHandleFetch = debounce(getTableData, 500);
  useEffect(() => {
    if (initialFetch === false) {
      setCurrentPage(0);
      debouncedHandleFetch();
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, []);

  const sendNotification = async (id, type) => {
    try {
      const response = await sendNotificationFemale(id, type);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const activateAccount = async (id) => {
    setLoader(true);
    try {
      const response = await activateAccountApi(id);
      notifyTopRight(response.data?.message);
      getTableData();
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const hideProfile = async (id) => {
    setLoader(true);
    try {
      const response = await hideProfileApi(id);
      notifyTopRight(response.data?.message);
      getTableData();
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const recoveAccount = async (id) => {
    try {
      const response = await recoverAccountApi(id);
      getTableData();
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  function formatTimestamp(timestamp) {
    const isSeconds = String(timestamp).length === 10;
    const timestampInMilliseconds = isSeconds ? timestamp * 1000 : timestamp;
    return moment(timestampInMilliseconds).format("DD-MM-YYYY, h:mm A");
  }

  return loader ? (
    <Spinner />
  ) : (
    <>
      <div className="">
        {/* ======================= ROW 1: Search / Age / Date / Reset - All Screens ======================= */}
        <div className="row g-3 align-items-end mb-3">
          {/* Search Input */}
          <div className="col-12 col-md-6 col-lg-4 d-flex gap-2">
            <input
              type="text"
              className="form-control py-3"
              placeholder="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                dispatch(serachFilterPost(e.target.value));
              }}
              onKeyDown={(e) => e.key === "Enter" && getTableDataSearch()}
            />
            <button
              className="btn btn-primary py-3 px-3"
              onClick={getTableDataSearch}
            >
              <i className="fa fa-search" />
            </button>
          </div>
          <div className="col-6 col-md-4 col-lg-4">
            <label className="form-label fw-semibold">Active Status</label>
            <select
              className="form-control py-2"
              value={activeStatus}
              onChange={(e) => {
                setActiveStatus(e.target.value);
                dispatch(activeStatusFilterPost(e.target.value));
              }}
            >
              <option value="completedAt">Completed At</option>
              <option value="createdAt">Created At</option>
              <option value="lastActive">Last Active</option>
            </select>
          </div>
        </div>
      </div>

      <Table responsive>
        <thead style={{ color: "black" }}>
          <tr>
            <th>
              <strong>Image</strong>
            </th>
            <th>
              <strong>NAME</strong>
            </th>
            <th>
              <strong>EMAIL</strong>
            </th>
            <th>
              <strong>Gender</strong>
            </th>
            <th>
              <strong>PHONE NUMBER</strong>
            </th>
            {/* <th>
              <strong>Referral Code</strong>
            </th>
            <th>
              <strong>Redeemed by</strong>
            </th> */}
            <th>
              <strong>STATUS</strong>
            </th>
            <th>
              <strong>created at</strong>
            </th>
            <th>
              <strong>Device</strong>
            </th>
            <th>
              <strong>Last Active</strong>
            </th>
            <th>
              <strong>Hide</strong>
            </th>
            <th>
              <strong>ACTION</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {users?.map((item, i) => (
            <tr
              key={i}
              onClick={() =>
                 window.open(`/user-details-internal?data=${item?._id}`, "_blank")
              }
              className="pointer"
            >
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    width: "1px",
                    border:
                      item?.gender === "male"
                        ? "2px solid blue"
                        : "2px solid pink",
                    padding: "0px",
                    height: "80px",
                  }}
                ></div>
                <img
                  src={
                    item?.images[0]?.url
                      ? imgBaseURl + item?.images[0]?.url
                      : dummmyImg
                  }
                  alt="img"
                  width={100}
                  height={80}
                  className="rounded"
                  onClick={() => {
                    setImageForView(imgBaseURl + item?.images[0]?.url);
                    setView(true);
                  }}
                />
              </td>
              <td>{item?.name}</td>
              <td>{item?.email}</td>
              <td>
                {item?.gender &&
                  item?.gender?.charAt(0).toUpperCase() +
                    item?.gender?.slice(1)}
              </td>
              <td>
                {item.countryCode && "+" + item.countryCode} {item?.phoneNumber}
              </td>
              {/* <td>{item?.myReferralCode}</td> */}

              {/* <td
                className={` ${item.referralCount > 0 ? "pointer" : ""}`}
                onClick={(event) => {
                  event.stopPropagation();

                  if (item.referralCount > 0) {
                    navigate("/redeemed-by", {
                      state: { id: item?.referralId },
                    });
                  }
                }}
              >
                {item.referralCount}
              </td> */}
              <td>
                {item?.isDeletedByAdmin ? (
                  <Badge bg="" className="badge-secondary">
                    Deleted by Admin
                  </Badge>
                ) : item?.isDeleted ? (
                  <Badge bg="" className="badge-secondary">
                    Deleted
                  </Badge>
                ) : item?.isBlocked ? (
                  <Badge bg="" className="badge-danger">
                    Disabled
                  </Badge>
                ) : item?.isDeactivated ? (
                  <Badge bg="" className="badge-warning">
                    Deactivated
                  </Badge>
                ) : (
                  !item?.isBlocked && (
                    <Badge bg="" className="badge-success">
                      Enabled
                    </Badge>
                  )
                )}
              </td>
              <td>{moment(item?.createdAt).format("MMM Do YYYY, h:mm A")}</td>
              <td>{item?.deviceType ? item?.deviceType.toUpperCase() : ""}</td>
              <td>{formatTimestamp(item?.lastApiCall)}</td>
              <td>
                <Badge bg="" className="badge-danger">
                  {item?.hideProfile && "Hide"}
                </Badge>
              </td>
              <td
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                {!item?.isDeleted ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="light sharp btn btn-info i-false"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {item?.gender === "female" && (
                        <Dropdown.Item
                          onClick={() => sendNotification(item._id, "all")}
                        >
                          Send Notification to all
                        </Dropdown.Item>
                      )}
                      {item?.gender === "male" && (
                        <Dropdown.Item onClick={() => hideProfile(item._id)}>
                          {item?.hideProfile ? "Unhide" : "Hide"} Profile
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        onClick={() => {
                          navigate("/chat", {
                            state: {
                              data: item?._id,
                              selectedTab: "users",
                              userName: item?.name,
                              search: search,
                              page: currentPage,
                              gender: item?.gender,
                              type: "table",
                              userType: "user",
                            },
                          });
                          dispatch(selectConversationNull(null));
                        }}
                      >
                        Chat
                      </Dropdown.Item>
                      {item?.gender === "female" && (
                        <Dropdown.Item
                          onClick={() => sendNotification(item._id, "premium")}
                        >
                          Send Notification to member
                        </Dropdown.Item>
                      )}
                      {item?.gender === "female" && (
                        <Dropdown.Item
                          onClick={() =>
                            sendNotification(item._id, "nonPremium")
                          }
                        >
                          Send Notification to non member
                        </Dropdown.Item>
                      )}
                      {/* {item?.isDeactivated && (
                        <Dropdown.Item
                          onClick={() => {
                            activateAccount(item._id);
                          }}
                        >
                          Activate Account
                        </Dropdown.Item>
                      )} */}
                      <Dropdown.Item
                        onClick={() => {
                          setShowDeleteModal(true);
                          setDeleteConfirmationId(item._id);
                        }}
                      >
                        Delete
                      </Dropdown.Item>
                      {item.isBlocked ? (
                        <Dropdown.Item onClick={() => onAction(item._id)}>
                          Enable
                        </Dropdown.Item>
                      ) : (
                        <Dropdown.Item onClick={() => onAction(item._id)}>
                          Disable
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="light sharp btn btn-info i-false"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => recoveAccount(item._id)}>
                        Recover Account
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {users?.length === 0 && !loader && (
        <div className="justify-content-center d-flex my-5">
          Sorry, Data Not Found!
        </div>
      )}
      {users?.length !== 0 && (
        <div className="card-footer clearfix">
          <div className="d-block d-sm-flex justify-content-between align-items-center">
            <div className="dataTables_info">
              Showing {currentPage * limit + 1} to{" "}
              {listLength > (currentPage + 1) * limit
                ? (currentPage + 1) * limit
                : listLength}{" "}
              of {listLength} entries
            </div>
            <Pagination
              pageCount={pageCount}
              pageValue={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        </div>
      )}
      <ConfirmationDeleteAccount
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={onDelete}
      />
    </>
  );
};

export default UsersTableInternal;
